export enum MicrosoftTenantType {
  NEW = "new",
  EXISTING = "existing",
}

export enum MicrosoftSpecialQualifications {
  NONE = "none",
  STATE_OWNED_ENTITY = "stateownedentity",
}
